import { render, staticRenderFns } from "./productWHList.vue?vue&type=template&id=3a6b0892&scoped=true&"
import script from "./productWHList.vue?vue&type=script&lang=js&"
export * from "./productWHList.vue?vue&type=script&lang=js&"
import style0 from "./productWHList.vue?vue&type=style&index=0&id=3a6b0892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b0892",
  null
  
)

export default component.exports